import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button, Box, Breadcrumbs, Typography } from '@mui/material/'

import { Circle } from '@mui/icons-material'
import Main from '@/views/layouts/main'
import ErrorLimit from '@/views/components/error-limit/index.component'

import { useUsersDialog, useUsersActions } from '@/views/users/hooks'
import UsersModule from '@/views/users/index.module'
import PageTitle from '@/views/layouts/page-title/index.layout'

import { RoleType, DialogsEnum, FormStatusType } from '@/enums'
import routes from '@/routes'

const UsersPage = () => {
  const { t } = useTranslation()

  const { toggleDialog, userSession } = useUsersDialog()

  const { setFormMode } = useUsersActions()

  const handleCreateUser = () => {
    setFormMode(FormStatusType.CREATE)
    toggleDialog(true, DialogsEnum.DIALOG_USERS)
  }

  const handleEditBrands = () => {
    toggleDialog(true, DialogsEnum.DIALOG_BRAND)
  }

  const isSuperAdmin = userSession.role.toString() === `${RoleType.SUPER_ADMIN}`

  const breadcrumbs = (
    <Breadcrumbs separator={<Circle sx={{ fontSize: 6, marginX: 2 }} />}>
      <Link to={routes.HOME}>
        <Typography>{t('pages.home')}</Typography>
      </Link>
      <Typography>{t('pages.users')}</Typography>
    </Breadcrumbs>
  )

  return (
    <Main>
      <ErrorLimit>
        <Box display="flex" mb={5}>
          <PageTitle
            title={t('pages.userManagement')}
            breadcrumbs={breadcrumbs}
          />
          {isSuperAdmin && (
            <Box display="flex" alignItems="center" flexShrink={0}>
              <Box mr={2}>
                <Button
                  onClick={handleEditBrands}
                  variant="outlined"
                  color="primary"
                >
                  {t('brands')}
                </Button>
              </Box>
              <Box>
                <Button onClick={handleCreateUser} variant="contained">
                  {t('createNewUser')}
                </Button>
              </Box>
            </Box>
          )}
        </Box>

        <UsersModule />
      </ErrorLimit>
    </Main>
  )
}

export default UsersPage
